import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import CarouselController from "./controllers/carousel_controller"
import TableOfContentsController from "./controllers/table_of_contents_controller"
import RecaptchaController from "./controllers/recaptcha_controller"
import AOSController from "./controllers/aos_controller"
import DropdownController from "./controllers/dropdown_controller"
import TabsController from "./controllers/tabs_controller"

// Start Stimulus
const application = Application.start()

// Register controllers
application.register("carousel", CarouselController)
application.register("table-of-contents", TableOfContentsController)
application.register("recaptcha", RecaptchaController)
application.register("aos", AOSController)
application.register("dropdown", DropdownController)
application.register("tabs", TabsController)